/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface ProjectFundingReferenceFundingSubstreamDTO
 */
export interface ProjectFundingReferenceFundingSubstreamDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectFundingReferenceFundingSubstreamDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectFundingReferenceFundingSubstreamDTO
     */
    fundingSubstream?: string;
}

/**
 * Check if a given object implements the ProjectFundingReferenceFundingSubstreamDTO interface.
 */
export function instanceOfProjectFundingReferenceFundingSubstreamDTO(value: object): value is ProjectFundingReferenceFundingSubstreamDTO {
    return true;
}

export function ProjectFundingReferenceFundingSubstreamDTOFromJSON(json: any): ProjectFundingReferenceFundingSubstreamDTO {
    return ProjectFundingReferenceFundingSubstreamDTOFromJSONTyped(json, false);
}

export function ProjectFundingReferenceFundingSubstreamDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectFundingReferenceFundingSubstreamDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'fundingSubstream': json['fundingSubstream'] == null ? undefined : json['fundingSubstream'],
    };
}

export function ProjectFundingReferenceFundingSubstreamDTOToJSON(json: any): ProjectFundingReferenceFundingSubstreamDTO {
    return ProjectFundingReferenceFundingSubstreamDTOToJSONTyped(json, false);
}

export function ProjectFundingReferenceFundingSubstreamDTOToJSONTyped(value?: ProjectFundingReferenceFundingSubstreamDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'fundingSubstream': value['fundingSubstream'],
    };
}


